module.exports = __webpack_public_path__ + "static/media/packageTix.4f81ce1e.png";